import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["id", "label"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProgressBar from "@Shared/components/general/progress-bar";
import { mapMutations, mapState } from "vuex";
import { cloneDeep, isEmpty } from "lodash";
import { SET_BOARDS_CLASSIC_FILTERS } from "@Broker/@Modules/main/store/account/account-mutations";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "StatesBar",
  components: {
    ProgressBar
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    states: {
      type: Array,
      default: () => [],
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      editingStatus: {},
      TEXT_LIMIT: 20
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["boardClassicFilters"])), mapState("BoardStore", ["boardsStatusesTranslationMap"])), {}, {
    currentFilters: {
      get() {
        return this.boardClassicFilters[this.boardId] || [];
      },
      set(value) {
        this.SET_BOARDS_CLASSIC_FILTERS({
          boardId: this.boardId,
          value
        });
      }
    },
    statusLabels() {
      var _context;
      if (!this.states) return [];
      return _mapInstanceProperty(_context = this.states).call(_context, _ref => {
        var _this$$options$filter, _context2;
        let {
            id,
            label
          } = _ref,
          data = _objectWithoutProperties(_ref, _excluded);
        return _objectSpread({
          id,
          stepName: (_this$$options$filter = this.$options.filters.getSchemaTranslation(label, this.boardsStatusesTranslationMap[this.boardId])) != null ? _this$$options$filter : label,
          selected: _includesInstanceProperty(_context2 = this.currentFilters).call(_context2, id)
        }, data);
      });
    }
  }),
  watch: {
    states: {
      immediate: true,
      handler(value, oldValue) {
        // If we are done loading data, and there is no filters
        // in account store, lets assign it as default to all statuses
        // We need this since the data is coming from localStorage and not ready
        // onMounted
        if (!isEmpty(value) && isEmpty(oldValue) && isEmpty(this.currentFilters)) {
          this.currentFilters = cloneDeep(_mapInstanceProperty(value).call(value, ({
            id
          }) => id));
        }
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations("AccountStore", [SET_BOARDS_CLASSIC_FILTERS])), {}, {
    formatMoneyValue(value) {
      return this.$options.filters.formatMoneyValue(value);
    },
    setEditing(editing, step) {
      const value = editing ? cloneDeep(step.stepName) : null;
      this.editingStatus = _objectSpread(_objectSpread({}, this.editingStatus), {}, {
        [step.id]: value
      });
      if (editing) {
        this.$nextTick(() => {
          this.$refs.editStatusInput.focus();
        });
      }
    },
    handleProgressBarChange({
      id,
      selected
    }) {
      if (selected) {
        this.currentFilters = _Array$from(new _Set([...this.currentFilters, id]));
      } else {
        var _context3;
        this.currentFilters = _filterInstanceProperty(_context3 = this.currentFilters).call(_context3, value => value !== id);
      }
    },
    handleLabelSubmit(stateId) {
      const newLabel = this.editingStatus[stateId];
      if (!newLabel) return;
      this.editingStatus[stateId] = null;
      this.$emit("submit", {
        label: newLabel,
        id: stateId
      });
    }
  })
});